import {useQuery, type UseQueryOptions} from '@tanstack/react-query'
import {type AxiosError} from 'axios'

import {riskSurveyQueries} from '../../api'
import type {AuditLogEntryDto} from '../../types'

import {riskSurveyQueryKeys} from './riskSurveyQueryKeys'

export const useRiaAuditLog = (
  riaId: string,
  options?: Omit<UseQueryOptions<AuditLogEntryDto[], AxiosError>, 'queryKey' | 'queryFn'>
) => {
  return useQuery<AuditLogEntryDto[], AxiosError>({
    queryKey: riskSurveyQueryKeys.rias.auditLog(riaId),
    queryFn: ({signal}) => riskSurveyQueries.getRiaAuditLog(riaId, signal),
    enabled: !!riaId,
    staleTime: 60_000,
    gcTime: 300_000,
    ...options
  })
}
